import React, { useEffect, useRef } from "react";

// --- Icons (Same as before) ---
const Icons = {
    Satisfaction: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
    ),
    Heart: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
        </svg>
    ),
    Texture: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 00 3 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
            <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
            <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
    ),
    Custom: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
        </svg>
    ),
    Rare: () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M6 3v18" />
            <path d="M18 3v18" />
            <path d="M6 12h12" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
};

const features = [

    {

        title: "Customer Satisfaction First",

        desc: "We believe our customers deserve nothing less than perfection. From design to delivery, your satisfaction is woven into every thread.",

        icon: <Icons.Satisfaction />,

    },

    {

        title: "Every Stitch Has a Heart",

        desc: "Our work is not mass-produced. Each piece is fully handcrafted, thoughtfully created to match your exact needs and vision.",

        icon: <Icons.Heart />,

    },

    {

        title: "Premium Touch & Texture",

        desc: "The embossed threads, smooth hoop finishes, and soft crochets offer a tactile experience that feels as premium as it looks.",

        icon: <Icons.Texture />,

    },

    {

        title: "Customization at Its Finest",

        desc: "We listen, understand, and create. Whether it’s a gift or a memory, we tailor every design to reflect your unique story.",

        icon: <Icons.Custom />,

    },

    {

        title: "Rare Craftsmanship",

        desc: "Keeping the tradition alive with modern designs, neat finishing, and high-quality materials in a world of machines.",

        icon: <Icons.Rare />,

    },

];

export default function WhyChooseUs() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("wcu-visible");
                    }
                });
            },
            { threshold: 0.2 }
        );

        const cards = document.querySelectorAll(".wcu-card-wrapper");
        cards.forEach((card) => observer.observe(card));

        return () => observer.disconnect();
    }, []);

    return (
        <section className="wcu-section" ref={sectionRef}>
            {/* Floating Leaf Background */}
            <div className="wcu-leaf-container">
                <img src="images/leaf.webp" alt="" className="wcu-leaf leaf-1" />
                <img src="images/leaf.webp" alt="" className="wcu-leaf leaf-2" />
                <img src="images/leaf.webp" alt="" className="wcu-leaf leaf-3" />
                <img src="images/leaf.webp" alt="" className="wcu-leaf leaf-4" />
                <img src="images/leaf.webp" alt="" className="wcu-leaf leaf-5" />
                <img src="images/leaf.webp" alt="" className="wcu-leaf leaf-6" />
            </div>
            <div className="wcu-container">

                {/* Header Section */}
                <div className="wcu-header">
                    <h2 className="wcu-title">Why Choose Us</h2>
                    <div className="wcu-underline"></div>
                    <p className="wcu-subtitle">The difference is in the details.</p>
                </div>

                {/* Timeline Container */}
                <div className="wcu-timeline">

                    {/* The Horizontal Line (Background) */}
                    <div className="wcu-line">
                        {/* <span className="wcu-needle-moving">🪡</span> */}
                    </div>

                    {/* Cards Loop */}
                    {features.map((feature, index) => {
                        // Determine if card goes UP or DOWN based on index (ZigZag)
                        const positionClass = index % 2 === 0 ? "top" : "bottom";

                        return (
                            <div
                                key={index}
                                className={`wcu-card-wrapper ${positionClass}`}
                                style={{ transitionDelay: `${index * 150}ms` }}
                            >
                                {/* The Connector Dot (Always on the center line) */}
                                <div className="wcu-connector">
                                    <div className="wcu-dot"></div>
                                </div>

                                {/* The Content Card */}
                                <div className="wcu-card">
                                    <div className="wcu-icon-box">{feature.icon}</div>
                                    <div className="wcu-content">
                                        <h3 className="wcu-card-title">{feature.title}</h3>
                                        <p className="wcu-card-desc">{feature.desc}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}